import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Spin } from 'antd';

const ProtectedRoute = ({ children }) => {
    const auth = useAuth();

    // Automatically redirect to authorization
    useEffect(() => {
        if (!auth.isLoading && !auth.isAuthenticated && !auth.error) {
            auth.signinRedirect();
        }
    }, [auth.isLoading, auth.isAuthenticated, auth.error, auth]);

    if (auth.isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column',
                gap: '20px'
            }}>
                <Spin size="large" />
                <div>Loading...</div>
            </div>
        );
    }

    if (auth.error) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column',
                gap: '20px'
            }}>
                <div>Authorization error: {auth.error.message}</div>
                <button onClick={() => auth.signinRedirect()}>
                    Try again
                </button>
            </div>
        );
    }

    if (!auth.isAuthenticated) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column',
                gap: '20px'
            }}>
                <Spin size="large" />
                <div>Redirecting to login page...</div>
            </div>
        );
    }

    return children;
};

export default ProtectedRoute;

